export default "__VITE_ASSET__b72b8deb__"